import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import { isBool, isObject } from '@jd/jmtd-tools/es/is';
import TypographyBasic from '../Typography/TypographyBasic';
import Measure from './components/Measure';

var Paragraph = function Paragraph(_ref) {
  var id = _ref.id,
      onExpend = _ref.onExpend,
      children = _ref.children,
      ellipsis = _ref.ellipsis,
      size = _ref.size,
      className = _ref.className,
      style = _ref.style,
      color = _ref.color,
      strong = _ref.strong,
      semantic = _ref.semantic,
      sign = _ref.sign,
      theme = _ref.theme;

  if (isObject(ellipsis) && !Object.keys(ellipsis).length) {
    ellipsis = {
      expandable: false,
      closable: false,
      expanded: true
    };
  }

  return /*#__PURE__*/React.createElement(TypographyBasic, {
    id: id,
    className: className,
    style: style,
    size: size,
    color: color,
    strong: strong,
    semantic: semantic,
    sign: sign,
    theme: theme
  }, /*#__PURE__*/React.createElement(Measure, {
    ellipsis: ellipsis,
    children: children
  }));
};

Paragraph.propTypes = _objectSpread(_objectSpread({}, TypographyBasic.propTypes), {}, {
  children: PropTypes.node,
  ellipsis: PropTypes.object
});
Paragraph.defaultProps = _objectSpread(_objectSpread({}, TypographyBasic.defaultProps), {}, {
  children: '',
  ellipsis: {}
});
export default Paragraph;